module.exports = __webpack_public_path__ + "assets/img/travel-day45.f1e6da74.png";